import axios from "axios";
import apiClient, {
    setAuthToken,
    setRememberToken,
    getRememberToken,
    clearAuthToken, setProfile,
} from "./apiClient";

const BASE_URL = "https://food.totalfresh.co/public/api/v2/admin";

export const login = async (email, password, rememberMe = false) => {
    const response = await axios.post(`${BASE_URL}/login`, { email, password });

    if (response.status !== 200) {
        throw new Error(response?.data?.message || "Invalid credentials. Please try again.");
    }

    const data = response.data;
    // data: { message, token, token_type, user: { auth_token, ... }, roles, dashboard }

    const authToken = data?.user?.auth_token;
    if (!authToken) throw new Error("No auth token received from server.");

    // Always store the JWT for this session
    setAuthToken(authToken);
    console.log("data: ", data);
    setProfile(data);
    apiClient.defaults.headers.common.Authorization = `Bearer ${authToken}`;

    // Only store remember_token if user checked "Remember Me"
    if (rememberMe) {
        // Store email or a remember identifier — adjust if your backend returns a dedicated remember_token
        setRememberToken(email);
    }

    return data;
};


// ── OTP Login ────────────────────────────────────────────────────────────────

export const generateOtp = async (phone) => {
    const response = await axios.post(`${BASE_URL}/generate-otp-dashboard`, { phone });
    if (response.status !== 200) {
        throw new Error(response?.data?.message || "Failed to send OTP.");
    }
    return response.data; // { otp: true, message: "OTP sent..." }
};

export const loginWithOtp = async (phone, otp) => {
    const response = await axios.post(`${BASE_URL}/login-with-otp`, { phone, otp });
    if (response.status !== 200) {
        throw new Error(response?.data?.message || "OTP verification failed.");
    }

    const data = response.data; // { success, token, token_type, user, roles, dashboard }

    const authToken = data?.token;
    if (!authToken) throw new Error("No auth token received from server.");

    setAuthToken(authToken);
    setProfile(data);
    apiClient.defaults.headers.common.Authorization = `Bearer ${authToken}`;

    return data;
};

export const getRememberedEmail = () => getRememberToken();

export const logout = () => {
    clearAuthToken();
    delete apiClient.defaults.headers.common.Authorization;
};

export const forgetAndLogout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("remember_token");
    delete apiClient.defaults.headers.common.Authorization;
};